module.exports = __webpack_public_path__ + "img/logoTemplusIntelite.84f6fb0d.png";